import { render, staticRenderFns } from "./RecruitingAndOnboardingCard.vue?vue&type=template&id=70c5c17b&scoped=true&"
import script from "./RecruitingAndOnboardingCard.vue?vue&type=script&lang=js&"
export * from "./RecruitingAndOnboardingCard.vue?vue&type=script&lang=js&"
import style0 from "./RecruitingAndOnboardingCard.vue?vue&type=style&index=0&id=70c5c17b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5c17b",
  null
  
)

export default component.exports